/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Operation type to be performed.
 */
export var OperationType;
(function (OperationType) {
    OperationType["CREATE"] = "create";
    OperationType["APPEND"] = "append";
    OperationType["REMOVE"] = "remove";
    OperationType["DELETE"] = "delete";
    OperationType["IGNORE"] = "ignore";
    OperationType["RECOVER"] = "recover";
})(OperationType || (OperationType = {}));
